/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscriptions_Nav_LabelInputs */

const fr_subscriptions_nav_label = /** @type {(inputs: Subscriptions_Nav_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnements`)
};

/**

* @param {Subscriptions_Nav_LabelInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const subscriptions_nav_label = /** @type {((inputs?: Subscriptions_Nav_LabelInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscriptions_Nav_LabelInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_subscriptions_nav_label(inputs)
});